import React from 'react';
import Navigation from './navigation';

export default class Account extends React.Component {

    componentDidMount() {
        if (!this.props.account.email) {
            this.props.getAccount();
        }
    }

    render() {
        const { account } = this.props;
        return (
            <div>
                <Navigation {...this.props} />
                <div className="min-h-screen bg-gray-200 p-4">
                    <div className="bg-white rounded mt-8 p-8 overflow-hidden shadow-lg w-full md:w-4/5 mx-auto">
                        <h2 className="text-xl font-bold my-4">Your account</h2>
                        {Boolean(account) &&
                            <div>
                                <div>{account.firstName} {account.lastName}</div>
                                <div>{account.email}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/account.js